






























































import {Component, Prop} from 'vue-property-decorator';
import ExporoVue from '../../ExporoVue';
import CockpitPanel from '../Controls/CockpitPanel.vue';
import CockpitButton from '../Controls/CockpitButton.vue';
import CockpitTimeline from '../Controls/CockpitTimeline.vue';
import Events from '@/events';
import UserData from '../models/UserData';
import DateFormatHelper from '../../Helper/DateFormatHelper';
import marked from 'marked';
import ContentfulRequestApi from '@/components/Rest/requests/ContentfulRequestApi';
import RequestCallback from '../../Rest/RequestCallback';
import RestError from '../../Rest/models/RestError';
import {AxiosResponse} from 'axios';
import Logger from '@/components/Helper/LogHelper';
import KpiPanel from '../Controls/KpiPanel.vue';
import KpiReport from '@/components/Cockpit/KPI/KpiReport.vue';
import KpiChart from '@/components/Cockpit/KPI/KpiChart.vue';
import KpiTable from '@/components/Cockpit/KPI/KpiTable.vue';
import DetailPanel from '@/components/Cockpit/KPI/DetailPanel.vue';
import SlotDetailPage from '@/components/Cockpit/KPI/SlotDetailPage.vue';
import SliderComponent from '@/components/SliderComponent/SliderComponent.vue';
import SliderPage from '@/components/SliderComponent/SliderPage.vue';
import CockpitTabBar from '@/components/Cockpit/Controls/CockpitTabBar.vue';
import OptionEntry from '@/components/Cockpit/models/OptionEntry';
import CockpitRequestApi from '@/components/Rest/requests/CockpitRequestApi';
import Update from '@/components/Cockpit/interfaces/Update';
import HistoryPanel from '@/components/Cockpit/KPI/HistoryPanel.vue';
import PageData from '@/components/Cockpit/models/PageData';
import ExporoModal from '@/components/Modal/ExporoModal.vue';
import Lightbox from 'vue-my-photos';
import PrintHelper from '@/components/Helper/PrintHelper';
import Router from '@/components/Router/Router';
import KpiHelper from '@/components/Helper/KpiHelper';
import DescriptionPerQuarterObject from '@/components/Cockpit/KPI/models/DescriptionPerQuarterObject';
import QuarterlyYieldReporting from '@/components/Cockpit/KPI/models/QuarterlyYieldReporting';
import QuarterlyIncome from '@/components/Cockpit/KPI/models/QuarterlyIncome';
import QuarterlyReport from '@/components/Cockpit/KPI/models/QuarterlyReport';
import Card from '@/components/Cockpit/models/Card';
import CardEntries from '@/components/Cockpit/interfaces/CardEntries';
import YieldReporting from '@/components/Cockpit/models/YieldReporting';
import ReportingKpis from '@/components/Cockpit/interfaces/ReportingKpis';
import SortHelper from '@/components/Helper/SortHelper';
import Investment, {InvestmentType} from '@/components/Cockpit/Financing/interfaces/investment';
import Payment from '@/components/Cockpit/interfaces/Payment';
import NumberHelper from '@/components/Helper/NumberHelper';
import MezzBondInvestment from '@/components/Cockpit/Financing/MezzBondInvestment';
import SigningInvestment from '@/components/Cockpit/Financing/SigningInvestment';
import LoanInvestment from '@/components/Cockpit/Financing/LoanInvestment';
import LocalStorage from '@/components/LocalStorage/LocalStorage';

const LOGGER_TAG: string = 'CockpitV2';

@Component({
  components: {
    CockpitPanel,
    KpiPanel,
    KpiReport,
    KpiTable,
    KpiChart,
    CockpitButton,
    CockpitTimeline,
    DetailPanel,
    SlotDetailPage,
    SliderComponent,
    SliderPage,
    CockpitTabBar,
    HistoryPanel,
    ExporoModal,
    Lightbox

  },
  filters: {
    readableFilename(url: string) {
      const indexFile = url.lastIndexOf('/');
      const indexExtension = url.lastIndexOf('.');
      return url.substring(indexFile + 1, indexExtension);
    }
  }
})
class PageDetail extends ExporoVue implements RequestCallback {

  @Prop() private userdata!: UserData;
  @Prop() private pagedata!: PageData;

  readonly isFinancing: boolean = false;

  private contentfulRequestApi: ContentfulRequestApi;
  private cockpitRequestApi: CockpitRequestApi;
  private card: Card | null = null;
  private yieldReporting!: YieldReporting;

  private updates: Update[] = [];
  private pageOptions: any[][] = [[]];
  private showWarning: boolean = false;
  private shoudShowHistory: boolean = false;
  private galleryIndex: any = null;
  private newsIndex: number = 0;
  private images: object[] = [];
  private yieldExpireAt: string = '';

  constructor() {
    super();
    this.contentfulRequestApi = this.restApi.create(new ContentfulRequestApi());
    this.cockpitRequestApi = this.restApi.create(new CockpitRequestApi());
    this.isFinancing = window.location.href.indexOf('cockpit/financing') > -1;

    this.userdata.rawData.investmentData.bestand.investments.forEach((el) => {
      if (el.isin === this.pagedata.data._isin) {
        this.yieldExpireAt = el.expire_at;
        this.shoudShowHistory = true;
      }
    });

    this.initKPIs();
  }

  getImageByInvestment(investment: Investment) {
    const projects = this.userdata.projects;
    const project = projects[investment.getFinancingEntity()];

    return {path: project && project.image ? project.image : 'https://exporo.de/images/bg-estate.png'};
  }

  goTo() {
    window.open(this.pagedata.data._reportingUrl, '_blank');
  }

  getStageImage() {

    if (this.isFinancing) {
      const investment: Investment = (this.pagedata.data as any);
      return `${this.getImageByInvestment(investment).path}?w=1100`;
    } else {
      const data: any = this.pagedata.data;
      if (data._image && data._image.path || data._image2 && data._image2.path) {
        return data._image ? data._image.path + '?w=1100' : data._image2.path + '?w=1100';
      }
    }

    return 'https://exporo.de/images/bg-estate.png';
  }

  initKPIs() {
    const pageData = this.pagedata.data;

    const reportingKpis: ReportingKpis = {
      project: pageData._title,
      expected_interest: pageData._expectedInterest + ' %',
      isin: pageData._isin,
      wkn: pageData._wkn,
    };
    this.yieldReporting = new YieldReporting(reportingKpis);
  }

  initCard() {
    const pageData: any = this.pagedata.data;

    if (this.isFinancing) {
      const investment = pageData as Investment;

      const cardEntries: any = {
        signing_id: investment.getId(),
        project: investment.getTitle(),
        interest: `${NumberHelper.formatNumber(investment.getInterest(), 2)} %`,
        investment: `${NumberHelper.formatNumber(investment.getInvestSum(), 2)} €`,
        payoutdate: DateFormatHelper.getFormattedDateFromString(DateFormatHelper.stringToAmericanDate(investment.getDatePayBack()), true),
        investor: investment.getInvestor()
      };

      this.card = new Card(cardEntries);
    } else {
      const cardEntries: CardEntries = {
        signing_id: pageData._signingId,
        project: pageData._title,
        interest: pageData._interest ? pageData._interest.toString() + ' %' : '',
        isin: pageData._isin,
        period: DateFormatHelper.getFormattedDateFromString(pageData._expireAt),
        wkn: pageData._wkn,
        piece_value: pageData._piece_value ? pageData._piece_value + ' €' : '',
        pieces: (pageData._pieces && pageData._pieces !== Infinity) ? pageData._pieces + ' ' + this.trans.get('cockpit.detailPanel.piece') : '',
        investment: (pageData._investment && pageData._investment !== Infinity) ? pageData._investment + ' €' : '',
        expected_interest: pageData._expectedInterest ? pageData._expectedInterest + ' %' : '',
        expected_total_interest: pageData._expectedTotalInterest ? pageData._expectedTotalInterest + ' %' : '',
        payoutdate: this.setPayoutDate(pageData),
        payoutsum: pageData._payoutsum ? pageData._payoutsum + ' €' : '',
        investor: pageData._investor,
      };

      this.card = new Card(cardEntries);
    }
  }

  mounted() {
    this.initCard();
    LocalStorage.add('UPDATES_' + this.pagedata.data._title, DateFormatHelper.getFormattedDate(new Date(), true));
    Events.$emit('updateDots');

    Events.$on('changeGalleryIndex', (conf: any) => {
      const update = this.updates[conf.newsIndex];

      if (update) {
        const images = update.gallery;
        if (images) {
          const lightboxImages: object[] = [];
          images.forEach((image) => {
            lightboxImages.push({
              name: `${escape(image)}?w=1180`
            });
          });

          this.images = lightboxImages;

          this.galleryIndex = conf.index;

          this.$nextTick(() => {
            const lightbox: any = this.$refs.hasOwnProperty('lightbox') ? this.$refs.lightbox : null;
            if (lightbox) {
              setTimeout(() => {

                const gallery = document.getElementsByClassName('lightbox')[0];

                if (gallery) {
                  const element = document.getElementsByClassName('cockpit-page')[1];
                  const bodyRect = document.body.getBoundingClientRect();
                  const elemRect = element.getBoundingClientRect();
                  const offset = -elemRect.top - bodyRect.top;

                  const close = document.getElementsByClassName('lightbox-close')[0];

                  gallery.setAttribute('style', `top: ${offset}px !important`);
                  close.setAttribute('style', `top: ${offset}px !important`);
                }
              }, 100);
            }
          });

          this.$nextTick(() => {
            const lightbox: any = this.$refs.hasOwnProperty('lightbox') ? this.$refs.lightbox : null;

            if (lightbox) {
              const image: any = this.images[this.galleryIndex];
              lightbox.show(escape(image.name));
            }
          });
        }
      }
    });

    if (this.pagedata.data.hasOwnProperty('_title') && 'Portfolio-Marburg' === this.pagedata.data._title) {
      this.showWarningModal();
    }

    const getFileType = (type: InvestmentType) => {
      switch (type) {
        case InvestmentType.LOAN:
          return 'loan';
        case InvestmentType.MEZZBOND:
          return 'mezzbond';
        case InvestmentType.SIGNING:
          return 'signing';
        default:
          return 'loan';
      }
    };

    this.isFinancing
      ? this.cockpitRequestApi.getFinancingDocuments(this)
        .addParam('userId', this.userdata.rawData.userData.id)
        .addParam('type', getFileType((this.pagedata.data as any).getType()))
        .addParam('signingId', (this.pagedata.data as any).getId().toString())
      : this.cockpitRequestApi.getDocumentData(this)
        .addParam('userId', this.userdata.rawData.userData.id)
        .addParam('type', this.pagedata.data._type)
        .addParam('isin', this.pagedata.data._isin);

    this.pageOptions = [
      [
        new OptionEntry(
          'details',
          'details',
          () => {
            Router.navigate('detailSlider', ['yield', this.pagedata.data._fp_id, 'details']);
          }
        ),
        new OptionEntry(
          'Reporting',
          'Reporting',
          () => {
            Router.navigate('detailSlider', ['yield', this.pagedata.data._fp_id, 'reporting']);
          }
        ),
      ]
    ];

    this.contentfulRequestApi.getKpiValues({
      query: {
        'content_type': 'project',
        'fields.financingEntityId': this.isFinancing ? (this.pagedata.data as any).getFinancingEntity().toString() : this.pagedata.data._id,
        'include': '3',
        'locale': 'LOCALHOST' === this.cctld ? 'de' : this.cctld.toLowerCase()
      }
    }, this);

    this.contentfulRequestApi.getUpdates({
      query: {
        'content_type': 'project',
        'fields.financingEntityId': this.isFinancing ? (this.pagedata.data as any).getFinancingEntity().toString() : this.pagedata.data._id,
        'locale': 'LOCALHOST' === this.cctld ? 'de' : this.cctld.toLowerCase()

      }
    }, this);

    Events.$emit('pageDetailLoaded');
  }

  setPayoutDate(payment) {
    if (payment._payoutdate === undefined) {
      return undefined;
    } else {
      return this.isPaybackStarted(payment) ? this.trans.get('cockpit.list_financing_payments.payback_started') : payment._payoutdate;
    }
  }

  isPaybackStarted(payment: any): boolean {
    if (payment._expected_at) {
      return new Date(DateFormatHelper.stringToAmericanDate(payment._expected_at || payment._expire_at)) < new Date() && null === payment._paid_at;
    }
    return false;
  }

  onSuccess(response: AxiosResponse, id): void {
    if ('getDocumentData' === id) {
      this.pagedata.documentData = response.data;
      if (!this.isFinancing) {
        this.$forceUpdate();
      }
    }

    if ('getKpiValues' === id) {
      const values: QuarterlyYieldReporting = (response as any).items[0]?.fields.quarterlyYieldReporting[0];
      this.extractYieldKpiValues(values);
    }

    if ('getUpdates' === id) {
      const updates: any = (response as any).items;
      this.extractFinancingProjectValues(updates);
    }
  }

  onFailure(error: RestError): void {
    Logger.tag(LOGGER_TAG).log('Axios failed:', error);
  }

  goBack() {
    const route = window.location.href;

    if (route && route.indexOf('cockpit/financing') > -1) {
      window.location.href = window.location.href.replace(/#(.*)$/, '') + '#/cockpit/financing';
    }

    if (route && route.indexOf('cockpit/yield') > -1) {
      window.location.href = window.location.href.replace(/#(.*)$/, '') + '#/cockpit/yield';
    }

    Events.$emit('router-back');
  }

  extractYieldKpiValues(values) {
    const reports: any[] = [];
    const incomeValues: any[] = [];

    values.fields.quarterlyDescription?.forEach((item: QuarterlyReport) => {
      item.fields.descriptionPerQuarter?.forEach((item) => {
        reports.push(item.fields);
      });
    });

    if (reports && reports.length) {
      const markedReports: DescriptionPerQuarterObject[] = [];

      reports.forEach((report) => {
        markedReports.push({
          quarter: report.quarter,
          currentDevelopmentTable: marked(report.currentDevelopmentTable || '') || ' ',
        });
      });

      this.yieldReporting.quarterlyReport = markedReports.reverse().slice(0, 1);
    }

    values.fields.quarterlyIncome?.forEach((quarterlyIncome: QuarterlyIncome) => {
      incomeValues.push(quarterlyIncome);
    });

    this.yieldReporting.quarterlyIncome = KpiHelper.sortByQuarters(incomeValues).slice(0, 4).reverse();
    this.yieldReporting.kpiCharts = values?.fields?.currentDevelopment;

  }

  extractFinancingProjectValues(items: any[]) {
    const pageUpdates: Update[] = [];

    items.forEach((item: any) => {
      item.fields?.updates?.forEach((update: any) => {
        if (update.fields) {
          const baseUpdate: Update = {
            title: update.fields.title,
            subtitle: DateFormatHelper.getFormattedDateFromString(update.fields.date, true),
            teaser: marked(update.fields.teaser || '') || ' ',
            text: marked(update.fields.content || '') || ' ',
            gallery: update.fields.gallery ?
              update.fields.gallery.map((img) => img.fields.file.url) : undefined
          };

          pageUpdates.push(baseUpdate);
        }
      });

      this.updates = SortHelper.sortArrayOfObjectsByDateWithKey(pageUpdates, 'subtitle');
    });
  }

  print(): void {
    const kpiReportCss = '.printbtn{display:none}pre{white-space: pre-wrap;white-space: -moz-pre-wrap;white-space: -pre-wrap;white-space: -o-pre-wrap;word-wrap: break-word;margin: 0;} .panel-title{font-size:19px;font-family:Oswald,sans-serif;color:#545454;max-width:500px;line-height:1.2;letter-spacing:.3px;padding-bottom:12px}.card-container{display:grid;grid-template:"1fr 1fr";grid-column-gap:80px;padding:5px 0 15px 0}.card-entry{font-family:"Open Sans",sans-serif;;display:flex;padding:10px 20px;justify-content:space-between;font-weight:bold;font-size:12px;letter-spacing:.3px;border-top:1px solid #e5e5e5}.card-key{color:#888}.card-value{color:#555;text-align:right}.card-value a{color:#51709c}.card-value-disabled{color:#aaa}li{list-style:circle}.kpi-description{font-size:12px;font-family:"Open Sans",sans-serif;padding:0px 0px 25px 20px;color:#888;line-height:1.5}@media screen and (max-width:900px){.card-container{display:none}.kpi-description{padding:0 20px 50px 20px}}';
    const kpiTableCss = '.kpi-panel-wrapper{page-break-inside:avoid;}.overflow{overflow:hidden !important}.kpi-panel-content{margin:0 0 35px 0;transition:all .8s ease;font-size:14px;line-height:1.5;letter-spacing:.3px;max-width:840px;width:840px}.kpi-panel-title{font-family:"Oswald",sans-serif;font-size:19px;color:#545454;max-width:500px;line-height:1.2;letter-spacing:.3px;padding-bottom:12px}table.vgt-table{display:flex;font-size:12px; font-family:\'Open Sans\',sans-serif;border-collapse:collapse;background-color:#fff;width:auto;table-layout:auto;border:0;padding:20px}table.vgt-table thead th{background-color:#fafafa}thead tr{display:block;float:left;width:180px;max-width:192px}tbody tr{display:block;float:left;min-width:50px;width:100px;max-width:1720px}th,td{display:block}.vgt-table.bordered th{border:0;border-bottom:1px solid #dcdfe6;font-weight:100}.vgt-table.bordered th:first-child{border-bottom:3px solid #dcdfe6;font-weight:700;color:#545454}.vgt-table.bordered th:nth-child(8){border-top:2px solid #dcdfe6;font-weight:700;color:#545454}.vgt-table.bordered th:nth-child(11){border-top:2px solid #dcdfe6;font-weight:700;color:#67a337}.vgt-table.bordered th:nth-child(12){font-weight:700;color:#67a337}.vgt-table.bordered th:nth-child(13){color:#67a337}.vgt-table.bordered td{border:0;border-bottom:1px solid #dcdfe6}.vgt-table.bordered td:first-child{border-bottom:3px solid #dcdfe6;font-weight:700;color:#545454}.vgt-table.bordered td:nth-child(8){border-top:2px solid #dcdfe6;font-weight:700;color:#545454}.vgt-table.bordered td:nth-child(11){border-top:2px solid #dcdfe6;font-weight:700;color:#67a337}.vgt-table.bordered td:nth-child(12){font-weight:700;color:#67a337}.vgt-table.bordered td:nth-child(13){color:#67a337}.vgt-right-align{text-align:right;display:block}.vgt-left-align{text-align:left;display:block}.vgt-left-align-bold{text-align:left;display:block;border-top:2px solid #dcdfe6}.bordered th{border-bottom:2px solid #dcdfe6;font-weight:700}.text-right{text-align:right}';
    const kpiPanelCss = '.hero{position:relative;margin:auto}.panel{margin-top:35px}.panel-content{transition:all .8s ease;overflow:hidden;font-size:14px;line-height:1.5;letter-spacing:.3px}.panel-content-footer{padding-top:10px}.panel-content-closed{padding-top:0;padding-bottom:0}.headline{display:none;font-size:25px;font-family:"Oswald",sans-serif;padding-left:40px;text-transform:uppercase;color:#fff;max-width:270px;line-height:1.4;animation:slidedown .3s forwards .1s}@media screen and (max-width:800px){.panel-content{padding-left:20px;padding-right:20px}.is-expanded .panel-content{padding-left:20px;padding-right:20px}}';
    const kpiChartCss = '.highcharts{margin-left:-50px;width:320px;transform: scale(0.8);page-break-inside:avoid;}.highcharts-title{width:200px;text-align:center!important;text-transform:uppercase;font-size:12px!important;font-weight:700;font-family:"Open Sans",sans-serif;fill:#565655!important}.highcharts-legend{font-size:6px!important;fill:#565655;color:#fff}@media (max-width:425px){.highcharts{width:100%}}';
    const kpiChartTwoCss = '.highcharts-container{overflow: unset !important;}.chart-container{margin-right:20px}.chart-container-child{page-break-inside:avoid;display:flex;flex-wrap:wrap;justify-content:space-around;transition:all .8s ease;font-size:14px;line-height:1.5;letter-spacing:.3px}';
    const stylesArray = [kpiReportCss, kpiTableCss, kpiPanelCss, kpiChartCss, kpiChartTwoCss];
    PrintHelper.print(document.getElementById('kpi-panel') as HTMLDivElement, stylesArray);
  }

  getWarningHTML() {
    return `<p>Wir möchten Sie darüber informieren, dass über das Vermögen der DEMA Deutsche Mikroapartment AG, Marburg (vormals firmierend unter Sciolla Investment GmbH & Co. KG; Emittentin der hier gezeigten Vermögensanlage), der Insolvenzantrag eingereicht wurde. Weitere Informationen finden Sie hier:
                      <a target="_blank" href="https://exporo-webapp-static-files.s3.amazonaws.com/PM_Portfolio+Marburg.pdf">Presseinformation Portfolio Marburg.</a>
                  </p>`;
  }

  showWarningModal() {
    setTimeout(() => {
      this.showWarning = true;
      this.$nextTick(() => {
        this.getModalService().openModal('warning');
      });
    }, 1000);
  }
}

export default PageDetail;
